import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../store/hooks";
import { useState } from "react";
import { setWorkflowNameStore } from "../../../store/one-query/workflowsSlice";
import WorkflowNameModal from "./WorkflowNameModal";
import { Box, Typography } from "@mui/material";
import WorkflowTemplateCard from "./WorkflowTemplateCard";

import { WorkflowTemplatesType } from "../../../Types/Workflow-Types";

interface WorkflowTemplatesProps{
  workflowTemplates:WorkflowTemplatesType[]
}

const WorkflowTemplates = ({
  workflowTemplates
}:WorkflowTemplatesProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [show, setShow] = useState<boolean>(false);
  const handleNavigateToCreateWorkflow = (name: string) => {
    dispatch(setWorkflowNameStore(name));
    navigate("/workflows/create-workflow");
  };
  const handleClose = () => {
    setShow(false);
    dispatch(setWorkflowNameStore(""));
  };
  return (
    <>
      <div className={`workflow-body-overView`}>
        <Box
          sx={{
            width: "100%",
            position: "relative",
            marginTop: "0px",
          }}
        >
          <img
            src="/Images/workflowStart.gif"
            style={{
              width: "100%",
              height: "120px",
            }}
          />
          <Box
            sx={{
              textAlign: "center",
              position: "absolute",
              top: "22%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              width: " 100%",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: "28px",
                lineHeight: "36px",
                letterSpacing: "0px",
                background:
                  "linear-gradient(90deg, #73A0C9 3.37%, #AAC8E2 55.29%, #FFFFFF 95.19%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Design the Process
            </Typography>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0.5px",
                color:"#FFF"
              }}
            >
              Power up productivity with custom flows.
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            padding: "16px",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            overflowY: "auto",
           scrollbarWidth: "none",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "400",
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              paddingBottom: "8px",
            }}
          >
            Get started with a template
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              gap: "12px",
            }}
          >
            {workflowTemplates?.map((template: any, i: number) => (
              <WorkflowTemplateCard
                key={i}
                content={template?.title}
                workflowData={template?.workflows[0]}
                order={i}
              />
            ))}
          </Box>
        </Box>
      </div>
      {show && (
        <WorkflowNameModal
          show={show}
          handleClose={handleClose}
          method={handleNavigateToCreateWorkflow}
        />
      )}
    </>
  );
};

export default WorkflowTemplates;
